/**
 * FeaturePath: 會員系統-其它-工具
 * Accountable: Landy Chu, AlexCH Cheng,
 */
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';
export const SET_MY_PRODUCTS = 'SET_MY_PRODUCTS';
